import PropTypes from "prop-types";
import clsx from "clsx";

const SectionTitleMain = ({ spaceTopClass, spaceBottomClass, titleText, subtitleText, description }) => {
    return (
        <div className={clsx("welcome-area", spaceTopClass, spaceBottomClass)}>
            <div className="container">
                <div className="welcome-content text-center">
                    <h5>{subtitleText}</h5>
                    <h1>{titleText}</h1>
                    <p dangerouslySetInnerHTML={{__html:description}}></p>
                </div>
            </div>
        </div>
    );
};

SectionTitleMain.propTypes = {
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
};

export default SectionTitleMain;
